import classNames from "classnames";
import React, { FC } from "react";
import { useMedia } from "react-use";

import { Icon } from "@/components/Icon";
import { MEDIA_SIZE_SM } from "@/core/media";
import { Flex, TStyleDirection } from "@/eworkitComponents";
import {
  buildBackgroundColorVariantClassNames,
  buildBorderColorVariantClassNames,
  buildTextColorVariantClassNames,
  TColorVariant,
} from "@/style/colorVariants";

import "./_badge.scss";

interface IBadgeProps {
  color?: TColorVariant;
  backgroundColor?: TColorVariant;
  borderColor?: TColorVariant;
  onClick?: () => void;
  className?: string;
  icon?: string;
  iconColor?: TColorVariant;
  contentMargin?: TStyleDirection;
  borderRadius?: string;
}

export const Badge: FC<IBadgeProps> = ({
  color = "inherit",
  backgroundColor = "background-card",
  borderColor = "grey4",
  onClick,
  children,
  className,
  icon,
  iconColor,
  contentMargin,
  borderRadius,
}) => {
  const baseClassName = "badge";
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);
  const borderRadiusValue = borderRadius || isSmallScreen ? "8px" : "16px";
  return (
    <div
      className={classNames(
        baseClassName,
        className,
        buildTextColorVariantClassNames(color),
        buildBackgroundColorVariantClassNames(backgroundColor),
        buildBorderColorVariantClassNames(borderColor),
        {
          [`${baseClassName}--clickable`]: onClick,
        },
      )}
      style={{ borderRadius: borderRadiusValue }}
      onClick={onClick}>
      <Flex direction="row" innerMargin="xs" align="center" margin={contentMargin}>
        {children}
        {icon && <Icon className={`${baseClassName}__icon`} icon={icon} color={iconColor || color} />}
      </Flex>
    </div>
  );
};
